var _defs, _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountBehalf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{stroke:#fff;stroke-miterlimit:10;stroke-width:6px;opacity:0.01;isolation:isolate;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 96,
    height: 96
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.62,19.9a14,14,0,1,0,14,14,14,14,0,0,0-14-14Zm0,20a6,6,0,1,1,6-6,6,6,0,0,1-6,6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.67,51.79A28.2,28.2,0,0,0,8.16,71.23a2.9,2.9,0,0,0,2.66,3.87h47.7a2.89,2.89,0,0,0,2.65-3.87,28.18,28.18,0,0,0-26.5-19.44Zm-14.79,15a19.61,19.61,0,0,1,29.57,0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66,23A12,12,0,1,0,78,35,12,12,0,0,0,66,23Zm0,16a4,4,0,1,1,4-4,4,4,0,0,1-4,4Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M66.57,51a19.85,19.85,0,0,0-9.45,2.43,26.8,26.8,0,0,1,6.64,6.06,11.35,11.35,0,0,1,2.79-.35,13.16,13.16,0,0,1,9.81,4.78H66.6a27.09,27.09,0,0,1,2.64,8.14H85.73c1.56,0,2.66-1.79,2.14-3.5C84.77,58.32,76.41,51,66.57,51Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountBehalf);
export default __webpack_public_path__ + "static/media/account-behalf.956928c59d8577bfc3e3be828f721dcd.svg";
export { ForwardRef as ReactComponent };